import OperationExpensesList from './components/List'

const OperationExpenses: React.FC = () => {
    return <OperationExpensesList />
}

export default OperationExpenses
